/** 
* Page : LivingSpacesView 
* 
* It's living space details
* 
*/

<template>
  <div>
  <!-- General description about living space -->
    <header class="items_container">
        <MainTitle
          :title="$t('living.mainTitle')"
          :subtitle="$t('living.subTitle')"
          background="title_blue"
        ></MainTitle>
    </header>
    <!-- Description about kitchen -->
    <main class="items_description">
      <div>
        <PresentationCard
          :anchor="$t('living.anchorKitchen')"
          :title="$t('living.textKitchen')"
          :items="kitchenItems"   
          :MoreInformationUrl="buttons.urlKitchen"
          :MoreInformationText="$t('living.moreInformation')"
          :item_alt="$t('living.altKitchen')"
          :item_url="pictures.srcKitchen"
          :id="kitchen"
          @show-more="openModal('kitchen')" 
          ></PresentationCard>
      </div>
      <div>
       <!-- Description about dining room -->
        <PresentationCard
          :anchor="$t('living.anchorDiningRoom')"
          :title="$t('living.textDiningRoom')"
          :items="diningRoomItems"     

          :MoreInformationUrl="buttons.urlDiningRoom"
          :MoreInformationText="$t('living.moreInformation')"
          :item_alt="$t('living.altDiningRoom')"
          :item_url="pictures.srcDiningRoom"
           :id="dining_room"
           @show-more="openModal('dining_room')" 
        ></PresentationCard>
      </div>

      <div>
      <!-- Description about living room -->
        <PresentationCard 
          :anchor="$t('living.anchorRoom')"
          :title="$t('living.textRoom')"
          :items="livingRoomItems"    
          :MoreInformationUrl="buttons.urlLivingRoom"
          :MoreInformationText="$t('living.moreInformation')"
          :item_alt="$t('living.altRoom')"
          :item_url="pictures.srcLivingRoom"
           :id="living_room"
           @show-more="openModal('living_room')" 
        ></PresentationCard>
      </div>

  <!-- If modal is visible, call popupContent to display popup with informations of a room id-->
      <div v-if="isModalVisible" class="modal_overlay" @click="closeModal">
      <div class="modal_content" @click.stop>
        <PopupContent 
        :titlepopup="$t('living.titlePopup')"
          :sections="currentLivingSpace.sections" 
          />
        <button class="close_button" @click="closeModal">X</button>
      </div>
    </div>
    </main>

    <!-- Informs the user of the house's location -->
     <footer class="dispo_btn">
      <PageLink
        :url="buttons.urlReservation"
        :text="$t('living.textButton')"
        background="blue"
      />

</footer>
      </div>
</template>

<script>
import MainTitle from "@/components/MainTitle.vue";
import PresentationCard from "@/components/PresentationCard.vue";
import PopupContent from "@/components/PopupContent.vue";
import PageLink from "@/components/PageLink.vue";
import fr from "@/locales/fr.json";
import en from "@/locales/en.json";
import de from "@/locales/en.json";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

export default {
 
  name: "LivingSpacesView",
 
    // import
  components: { 
    MainTitle, 
    PresentationCard, 
    PopupContent,
    PageLink },

     setup() {
      const { locale } = useI18n();

      const mapKitchenItems = {
    fr: fr.living.kitchenItems,
    en: en.living.kitchenItems,
    de: de.living.kitchenItems
  };
  const mapDiningRoomItems = {
    fr: fr.living.diningRoomItems,
    en: en.living.diningRoomItems,
    de: de.living.diningRoomItems
  };
  const mapLivingRoomItems = {
    fr: fr.living.livingRoomItems,
    en: en.living.livingRoomItems,
    de: de.living.livingRoomItems
  };

  const mapSectionsKitchen = {
    fr: fr.living.sections.sectionKitchen,
    en: en.living.sections.sectionKitchen,
    de: de.living.sections.sectionKitchen
  };
  const mapSectionsDiningRoom = {
    fr: fr.living.sections.sectionDiningRoom,
    en: en.living.sections.sectionDiningRoom,
    de: de.living.sections.sectionDiningRoom
  };
  const mapSectionsLivingRoom = {
    fr: fr.living.sections.sectionLivingRoom,
    en: en.living.sections.sectionLivingRoom,
    de: de.living.sections.sectionLivingRoom
  };

  const mapAvisClients = {
    fr: fr.reviews.avisClients,
    en: en.reviews.avisClients,
    de: de.reviews.avisClients
  };

  const kitchenItems = computed(() => mapKitchenItems[locale.value] || fr.living.kitchenItems);
  const diningRoomItems = computed(() => mapDiningRoomItems[locale.value] || fr.living.diningRoomItems);
  const livingRoomItems = computed(() => mapLivingRoomItems[locale.value] || fr.living.livingRoomItems);

  const sectionsKitchen = computed(() => mapSectionsKitchen[locale.value] || fr.living.sections.sectionKitchen);
  const sectionsDiningRoom = computed(() => mapSectionsDiningRoom[locale.value] || fr.living.sections.sectionDiningRoom);
  const sectionsLivingRoom = computed(() => mapSectionsLivingRoom[locale.value] || fr.living.sections.sectionLivingRoom);

  const avisClients = computed(() => mapAvisClients[locale.value] || fr.reviews.avisClients);

    return { kitchenItems, livingRoomItems, diningRoomItems, sectionsKitchen, sectionsDiningRoom, sectionsLivingRoom, avisClients}
  },

  data() {
    return {
      kitchen:null,dining_room:null,living_room:null,
      
      isModalVisible: false, //by default the modal isn't activ (don't display popup)
      currentLivingSpace: {}, //by default no id livingspace is contain
      
      pictures: {
        srcKitchen:[
          require("../assets/images/living/kitchen1.jpg"),
          require("../assets/images/living/kitchen2.jpg")],
         srcLivingRoom:[
          require("../assets/images/living/living1.jpg"),
          require("../assets/images/living/living2.jpg")
        ],
        srcDiningRoom:[
          require("../assets/images/living/food.jpg"),
          require("../assets/images/living/food2.jpg"),
        
        ],
      },
      buttons: {
        urlReservation: "/diponible-merrien",
      },
   
    };
  },

  //if modal is true and contain an id, display informations about room id (look call component PopupContent)
  methods:{
    openModal(livingSpaceId){
      this.isModalVisible = true;
      this.$nextTick(() => {
        // Ajoute la classe `visible` pour commencer l'animation
        document.querySelector('.modal_overlay').classList.add('visible');
        document.querySelector('.modal_content').classList.add('visible');
      });
      switch (livingSpaceId){
         case "kitchen":
    this.currentLivingSpace = { sections: this.sectionsKitchen };
    break;
  case "dining_room":
    this.currentLivingSpace = { sections: this.sectionsDiningRoom };
    break;
  case "living_room":
    this.currentLivingSpace = { sections: this.sectionsLivingRoom };
    break;
        default:
          return this.isModalVisible = false;
      }
    },
    closeModal() {
      this.isModalVisible = false;
      this.isModalVisible = false;
      document.querySelector('.modal_overlay').classList.remove('visible');
      document.querySelector('.modal_content').classList.remove('visible');

         // Cache le modal après l'animation
         setTimeout(() => {
        this.isModalVisible = false;
      }, 300); // Doit correspondre à la durée de l'animation
    }
  },
    //gère le overflow du body pour qu'il soit figé quand le popup est ouvert
   watch: {
  isModalVisible(newVal) {
    if (newVal) {
       const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';  // Bloque scroll page
       document.body.style.marginRight = `${scrollbarWidth}px`; // ← Ajout important
    } else {
      document.body.style.overflow = '';        // Restaure scroll page
       document.body.style.marginRight = ''; // ← Restaure le margin
    }
  }
  }
};
</script>
